export default __webpack_public_path__ + "static/media/scan.05ad42e5.png";